var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2830_574)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#171818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28564 10H19.2856",
    stroke: "#fff",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4287 7.14286L19.2859 10L16.4287 12.8571",
    stroke: "#fff",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 16.4143C15.4315 17.7514 13.7781 18.6741 11.9666 19.0638C10.1551 19.4534 8.26844 19.2923 6.5493 18.6009C4.83017 17.9096 3.35717 16.7198 2.31977 15.1845C1.28238 13.6492 0.728027 11.8386 0.728027 9.98571C0.728027 8.13279 1.28238 6.32223 2.31977 4.78693C3.35717 3.25163 4.83017 2.0618 6.5493 1.37049C8.26844 0.679172 10.1551 0.517988 11.9666 0.907667C13.7781 1.29735 15.4315 2.22007 16.7143 3.55714",
    stroke: "#fff",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2830_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bbda5589c2166a4fced7b96fa93f4ebc.svg";
export { ForwardRef as ReactComponent };